import React, { useState } from 'react';
import { SortDescFilled, SortAscFilled } from '@tag/tag-icons';

import styles from './sorting-button.module.scss';
import { useEffectExceptOnMount } from '@/hooks/useEffectExceptOnMount.hook';
import { OrderType } from '@/graphql/contracts/_generated_/contracts';

const sortingStates = {
  [OrderType.Ascending]: {
    icon: <SortDescFilled  size="24" />,
    text: 'Ascending sort'
  },
  [OrderType.Descending]: {
    icon: <SortAscFilled size="24" />,
    text: 'Descending sort'
  }
};

interface ISortingButtonProps {
  defaultState?: OrderType;
  onChange?: (state: OrderType) => void;
  disabled?: boolean;
}

export default function SortingButton({
  onChange,
  defaultState = OrderType.Descending,
  disabled,
}: ISortingButtonProps) {
  const [state, setState] = useState<OrderType>(defaultState);

  const handleClick = () => {
    setState(state === OrderType.Ascending ? OrderType.Descending : OrderType.Ascending);
  };

  useEffectExceptOnMount(() => {
    onChange?.(state);
  }, [state]);

  return (
    <button
      className={styles.button}
      onClick={handleClick}
      disabled={disabled}
    >
      <span className={styles.icon}>
        {sortingStates[state].icon}
      </span>

      <span className={styles.text}>
        {sortingStates[state].text}
      </span>
    </button>
  );
}
